
import { defineComponent } from 'vue'

// newstype information
interface NewsTypeInfo {
  [type: string]: {
    text: string
  }
}

// news information
interface NewsInfo {
  date: string,
  type: string,
  text: string
}

export default defineComponent({
  data () {
    return {
      newstype: {
        cv: { text: '[CV]' },
        publication: { text: '[Publications]' },
        presentation: { text: '[Presentations]' },
        etc: { text: '' }
      } as NewsTypeInfo,
      news: [
        {
          date: 'January 27, 2026',
          type: 'publication',
          text: 'Our new paper on boundary conditions for phonon distribution functions at a smooth crystal interface and interfacial angular momentum transfer is now on <a href="https://arxiv.org/abs/2601.18584" target="_blank">arXiv:2601.18584</a>.'
        },
        {
          date: 'October 15, 2025',
          type: 'publication',
          text: 'Our paper on phase-modulated superconductivity via altermagnetism is published in <a href="https://link.aps.org/doi/10.1103/3k12-2467" target="_blank">Phys. Rev. B</a>.'
        },
        {
          date: 'September 29, 2025',
          type: 'presentation',
          text: 'Made an oral presentation in The 16th International Symposium on Crystalline Organic Metals, Superconductors and Magnets.'
        },
        {
          date: 'September 16, 2025',
          type: 'publication',
          text: 'Our new paper on chirality-dependent spin polarization in metals is now on <a href="https://arxiv.org/abs/2408.04450" target="_blank">arXiv:2408.04450</a>.'
        },
        {
          date: 'August 8, 2025',
          type: 'presentation',
          text: 'Made a poster presentation in The 30th International Conference on Low Temperature Physics.'
        },
        {
          date: 'July 25, 2025',
          type: 'publication',
          text: 'A short review is now on <a href="https://journals.jps.jp/doi/10.7566/JPSJNC.22.08" target="_blank">JSPJ News and Comments</a>.'
        },
        {
          date: 'July 8, 2025',
          type: 'presentation',
          text: 'Made an oral presentation in Conference on Strongly Correlated Electron Systems 2025.'
        },
        {
          date: 'June 30, 2025',
          type: 'publication',
          text: 'Our new paper on phase-modulated superconductivity via altermagnetism is now on <a href="https://arxiv.org/abs/2506.22297" target="_blank">arXiv:2506.22297</a>.'
        },
        {
          date: 'June 18, 2025',
          type: 'presentation',
          text: 'Made a poster presentation in International Workshop on Chirality in Condensed Matter Physics.'
        },
        {
          date: 'April 1, 2025',
          type: 'cv',
          text: 'Started a new project supported by Grant-in-Aid for Transformative Research Areas (A) “Chimera Quasiparticle”.'
        },
        {
          date: 'March 14, 2025',
          type: 'presentation',
          text: 'Made a poster presentation in The 23rd Korea-Taiwan-Japan Symposium on Strongly Correlated Electron System.'
        },
        {
          date: 'February 17, 2025',
          type: 'presentation',
          text: 'Made a poster presentation in Workshop on theory of cross correlations, multipoles, and computational material design.'
        },
        {
          date: 'November 15, 2024',
          type: 'publication',
          text: 'Our paper on ideal spin-orbit-free semimetals in the <i>RE</i><sub>8</sub>Co<i>X</i><sub>3</sub> group is published in <a href="https://doi.org/10.1038/s43246-024-00635-9" target="_blank">Commun. Mater.</a>'
        },
        {
          date: 'November 9, 2023',
          type: 'publication',
          text: 'Our paper on spin-orbit enabled unconventional Stoner magnetism is published in <a href="https://www.pnas.org/doi/10.1073/pnas.2411038121" target="_blank">Proc. Natl. Acad. Sci.</a>'
        },
        {
          date: 'September 16, 2024',
          type: 'publication',
          text: 'Our new paper on phonon angular momentum transport across interfaces is now on <a href="https://arxiv.org/abs/2409.08874" target="_blank">arXiv:2409.08874</a>.'
        },
        {
          date: 'September 7, 2024',
          type: 'publication',
          text: 'Our paper on anisotropy-induced spin parity effects is published in <a href="https://journals.aps.org/prb/abstract/10.1103/PhysRevB.110.L100403" target="_blank">Phys. Rev. B</a>.'
        },
        {
          date: 'July 2, 2024',
          type: 'presentation',
          text: 'Made a poster presentation in <a href="https://www.icm2024.org/" target="_blank">The 22nd International Conference on Magnetism</a>.'
        },
        {
          date: 'June 18, 2024',
          type: 'presentation',
          text: 'Made a poster presentation in <a href="https://events.unifr.ch/ttqm2024/" target="_blank">Trends in the Theory of Quantum Materials 2024</a>.'
        },
        {
          date: 'March 8, 2024',
          type: 'presentation',
          text: 'Made an oral presentation in APS March Meeting 2024.'
        },
        {
          date: 'March 1, 2024',
          type: 'publication',
          text: 'Our new paper on anisotropy-induced spin parity effects is now on <a href="https://arxiv.org/abs/2402.19311" target="_blank">arXiv:2402.19311</a>.'
        },
        {
          date: 'January 26, 2024',
          type: 'publication',
          text: 'Our new paper on ideal spin-orbit-free semimetals in the <i>RE</i><sub>8</sub>Co<i>X</i><sub>3</sub> group is now on <a href="https://arxiv.org/abs/2401.13930" target="_blank">arXiv:2401.13930</a>.'
        },
        {
          date: 'November 28, 2023',
          type: 'publication',
          text: 'Our paper on antiferromagnetism-induced FFLO state in κ-type organic conductors is published in <a href="https://journals.aps.org/prresearch/abstract/10.1103/PhysRevResearch.5.043171" target="_blank">Phys. Rev. Research</a>.'
        },
        {
          date: 'October 17, 2023',
          type: 'presentation',
          text: 'Made an oral presentation in Trends in the Theory of Quantum Materials 2023.'
        },
        {
          date: 'October 3, 2023',
          type: 'publication',
          text: 'Our new paper on spin-orbit enabled unconventional Stoner magnetism is now on <a href="https://arxiv.org/abs/2310.00838" target="_blank">arXiv:2310.00838</a>.'
        },
        {
          date: 'August 29, 2023',
          type: 'publication',
          text: 'Our new paper on antiferromagnetism-induced FFLO state in κ-type organic conductors is now on <a href="https://arxiv.org/abs/2308.14227" target="_blank">arXiv:2308.14227</a>.'
        },
        {
          date: 'July 4, 2023',
          type: 'presentation',
          text: 'Made a poster presentation in <a href="https://www.sces2023.org" target="_blank">International Conference on Strongly Correlated Electron Systems 2023</a>, and achieved a Best Poster Award.'
        },
        {
          date: 'July 1, 2023',
          type: 'publication',
          text: 'Our paper on crystal-symmetry-protected gapless vortex-line phases in Dirac semimetals is published in <a href="https://journals.aps.org/prb/abstract/10.1103/PhysRevB.107.214518" target="_blank">Phys. Rev. B</a>.'
        },
        {
          date: 'April 19, 2023',
          type: 'cv',
          text: 'Started two new projects supported by Grant-in-Aid for Early-Career Scientists and Grant-in-Aid for Scientific Research (C).'
        },
        {
          date: 'March 7, 2023',
          type: 'presentation',
          text: 'Made an oral presentation in APS March Meeting 2023.'
        },
        {
          date: 'February 16, 2023',
          type: 'publication',
          text: 'Our new paper on crystal-symmetry-protected gapless vortex-line phases in Dirac semimetals is now on <a href="https://arxiv.org/abs/2302.07451" target="_blank">arXiv:2302.07451</a>.'
        },
        {
          date: 'November 17, 2022',
          type: 'presentation',
          text: 'Made an oral presentation in <a href="https://www2.yukawa.kyoto-u.ac.jp/~nqs2022/" target="_blank">Novel Quantum States in Condensed Matter 2022</a>.'
        },
        {
          date: 'September 1, 2022',
          type: 'etc',
          text: 'Moved to The University of Tokyo.'
        },
        {
          date: 'August 23, 2022',
          type: 'presentation',
          text: 'Made a poster presentation in <a href="https://www.lt29.jp" target="_blank">29th International Conference on Low Temperature Physics</a>.'
        },
        {
          date: 'August 1, 2022',
          type: 'publication',
          text: 'Our paper on supercurrent-induced Weyl superconductivity is introduced by <a href="https://doi.org/10.7566/JPSHT.2.028" target="_blank">the online article</a> in JPS Hot Topics.'
        },
        {
          date: 'July 13, 2022',
          type: 'publication',
          text: 'Our paper on supercurrent-induced topological phase transition is published in <a href="https://journals.aps.org/prb/abstract/10.1103/PhysRevB.106.014508" target="_blank">Phys. Rev. B</a>.'
        },
        {
          date: 'June 3, 2022',
          type: 'publication',
          text: 'Our paper on supercurrent-induced Weyl superconductivity is published in <a href="https://journals.jps.jp/doi/abs/10.7566/JPSJ.91.074703" target="_blank">J. Phys. Soc. Jpn.</a>'
        },
        {
          date: 'January 20, 2022',
          type: 'publication',
          text: 'Our new paper on supercurrent-induced Weyl superconductivity is now on <a href="https://arxiv.org/abs/2201.07397" target="_blank">arXiv:2201.07397</a>.'
        },
        {
          date: 'January 13, 2022',
          type: 'publication',
          text: 'Our paper on LaNiGa<sub>2</sub> is published in <a href="https://www.nature.com/articles/s42005-021-00771-5" target="_blank">Commun. Phys.</a>'
        },
        {
          date: 'December 28, 2021',
          type: 'publication',
          text: 'Our review paper on superconducting gap classification theory is introduced by <a href="https://doi.org/10.7566/JPSHT.1.068" target="_blank">the online article</a> in JPS Hot Topics.'
        },
        {
          date: 'November 30, 2021',
          type: 'publication',
          text: 'Our paper on topological SNS junctions is published in <a href="https://journals.aps.org/prb/abstract/10.1103/PhysRevB.104.205431" target="_blank">Phys. Rev. B</a>.'
        },
        {
          date: 'November 10, 2021',
          type: 'publication',
          text: 'Our review paper on superconducting gap classification theory is published in <a href="https://doi.org/10.1093/ptep/ptab124" target="_blank">PTEP</a> online, and is selected as Editor\'s Choice.'
        },
        {
          date: 'October 15, 2021',
          type: 'publication',
          text: 'Our new paper on supercurrent-induced topological phase transition is now on <a href="https://arxiv.org/abs/2110.06959" target="_blank">arXiv:2110.06959</a>.'
        },
        {
          date: 'October 5, 2021',
          type: 'presentation',
          text: 'Made an invited online seminar in Nagoya Univ.'
        },
        {
          date: 'September 16, 2021',
          type: 'publication',
          text: 'Our new paper on LaNiGa<sub>2</sub> is now on <a href="https://arxiv.org/abs/2109.06983" target="_blank">arXiv:2109.06983</a>.'
        },
        {
          date: 'September 8, 2021',
          type: 'publication',
          text: 'Our new paper on topological SNS junctions is now on <a href="https://arxiv.org/abs/2109.02918" target="_blank">arXiv:2109.02918</a>.'
        },
        {
          date: 'July 14, 2021',
          type: 'publication',
          text: 'Our new review paper on superconducting gap classification theory is now on <a href="https://arxiv.org/abs/2107.05801" target="_blank">arXiv:2107.05801</a>.'
        },
        {
          date: 'January 22, 2021',
          type: 'presentation',
          text: 'Made an invited online seminar in UC Davis.'
        },
        {
          date: 'December 17, 2020',
          type: 'publication',
          text: 'My PhD Thesis has been published as the series "Springer Theses".'
        },
        {
          date: 'September 30, 2020',
          type: 'presentation',
          text: 'Made an invited presentation in Tohoku University - RIKEN Joint Workshop — Math meets Quantum Materials —.'
        },
        {
          date: 'August 12, 2020',
          type: 'publication',
          text: 'Our paper "Superconductivity induced by fluctuations of momentum-based multipoles" is published in <a href="https://journals.aps.org/prresearch/abstract/10.1103/PhysRevResearch.2.033225" target="_blank">Phys. Rev. Research</a>.'
        },
        {
          date: 'July 21, 2020',
          type: 'publication',
          text: 'Our paper "Superconductivity induced by fluctuations of momentum-based multipoles" is accepted in Phys. Rev. Research.'
        },
        {
          date: 'May 7, 2020',
          type: 'etc',
          text: 'The new website is open.'
        }
      ] as NewsInfo[]
    }
  }
})
